import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'
import { TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/composedReport/translations/TRANSLATION_KEYS'
import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'
import { addToScope } from 'legacy/lut/features/partner360/composedReport'
import { useCallback, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Textarea } from 'core-components/library/inputs'
import { LoaderOverlay } from 'core-components/library/loader'
import { ModalDialog } from 'core-components/library/modalDialog'

import { applyClipboardValues } from './api/applyClipboardValues'
import { ClipboardResultModalContent } from './clipboardResultModalContent/ClipboardResultModalContent'
import { getFilteredPartnerIds } from './helpers/getFilteredPartnerIds'

import styles from './PasteFromClipboardContent.module.scss'

interface IProps {
  onClose: () => void
}

export const PasteFromClipboardContent = ({ onClose }: IProps) => {
  const [value, setValue] = useState('')
  const [isWip, setIsWip] = useState(false)
  const [showClipboardResultModal, setShowClipboardResult] = useState(false)
  const [payloadCount, setPayloadCount] = useState(0)
  const [partnersResponse, setPartnersResponse] = useState<IWWPartners[]>([])
  const [unmatchedValues, setUnmatchedValues] = useState<string[]>([])
  const dispatch = useDispatch()

  const isDisabledApplyBtn = useMemo(() => value.length === 0, [value])

  const closeClipboardModalContent = useCallback(() => {
    setShowClipboardResult(false)
  }, [])

  const contentProps = useMemo(
    () => ({
      payloadCount,
      responseCount: partnersResponse.length,
      unmatchedValues,
      onClose: () => {
        closeClipboardModalContent()
        dispatch(addToScope(partnersResponse))
        onClose()
      },
    }),
    [payloadCount, partnersResponse, dispatch, onClose, unmatchedValues, closeClipboardModalContent]
  )

  const onApply = useCallback(async () => {
    setIsWip(true)
    const filteredPartnerIds = getFilteredPartnerIds(value)
    setPayloadCount(filteredPartnerIds.length)
    const { foundPartners, unmatched } = await applyClipboardValues(filteredPartnerIds)
    setPartnersResponse(foundPartners)
    setUnmatchedValues(unmatched)
    setShowClipboardResult(true)
    setIsWip(false)
  }, [value])

  return (
    <div>
      <LoaderOverlay show={isWip} />
      <WidgetHeader>{TRANSLATION_KEYS.pasteFromClipboardTitle}</WidgetHeader>
      <Textarea value={value} onChange={setValue} rows={10} />
      <div className={styles.btnWrapper}>
        <Button disabled={isDisabledApplyBtn} className={styles.btnWrapper__btn} onClick={onApply}>
          <Translation text={TRANSLATION_KEYS.clipboardApply} />
        </Button>
        <Button color={'danger'} onClick={onClose}>
          <Translation text={TRANSLATION_KEYS.clipboardCancel} />
        </Button>
      </div>
      <ModalDialog
        content={ClipboardResultModalContent}
        contentProps={contentProps}
        show={showClipboardResultModal}
        size={'xs'}
        onClose={closeClipboardModalContent}
      />
    </div>
  )
}
